jQuery(function($) {
  'use strict';

  window.RollwSmallCards = {
    carouselSettings: {
      loop: false,
      margin: 20,
      nav: true,
      navText: ['<span class="icon icon-chevron-left"></span>', '<span class="icon icon-chevron-right"></span>'],
      responsive: {
        0: {
          items: 2,
          slideBy: 2
        },
        600: {
          items: 4,
          slideBy: 4
        },
        1000: {
          items: 6,
          slideBy: 6
        }
      }
    },
    registerCarousels: function() {
      $('.rollw-small-cards.owl-carousel:not(#related-pros-container)').owlCarousel(this.carouselSettings);
    },
    init: function() {
      this.registerCarousels();
    }
  };
  window.RollwSmallCards.init();

  var addHeaderMobileClass = function() {
    if ($('.main-menu .toggleMenu').hasClass('isMobile')) {
      $('#site-header').addClass('isMobile');
    } else {
      $('#site-header').removeClass('isMobile');
    }
  }

  $(window).resize(addHeaderMobileClass);
});
